export default {
  hotRecommend: [],
  allDest: [],
  hotInternal: [],
  allInternal: []
}



// WEBPACK FOOTER //
// ./src/store/state.js